const containsString = (sentence: string, word: string): boolean =>
  new RegExp(word.trim().replace(/\s\s+/g, ' ').replace(/(\W)/g, '\\$1'), 'gi').test(sentence);

export default containsString;
